/* 南方洋行 · 墨と光 首屏：帳場の棚（3D 唱片架，10/29，README §9.97）
   上面是墙上的一条窄架，几张唱片和 CD 面朝前等距排开、互不遮挡；下面是帳場（柜台）。
   选中的一张从架上取下来，立在柜台上（原尺寸、封面朝左前方），唱片从封套（CD 从盒子）里滑出半张、慢慢转；
   架上空出来的那格下面有一道墨色短线。指针在架上的一张上停一下（约 0.26 秒）就换成它，点一下也换；
   点柜台上的这张，在点的位置弹出「この一枚を見る」。
   （第一版把选中的一张拿到左前方，正好挡住架子最左边的李志 CD，店主：「要再优雅清晰一些」，10/29 改成上架下台）
   左边的文字（艺人、标题、导语、按钮）、舞台角上的注记、下面的目录跟着切换；放着不动时按区块设置自动换下一张
   （指针在首屏里、页面不在视野里、偏好减少动画时不自动换）。手机上左右滑动也能换。
   材质、灯光、环境贴图、标签和 CD 印刷沿用 assets/nanpo-hero-3d.js（从那里 import）。
   three.js 载入失败或没有 WebGL 时，保留静态的封面排（.nh-sfb），文字和目录照样能切换。
   黑胶的盘色读商品 metafield custom.vinyl_color（black／clear／#颜色值），和商品卡一致。
   第三方厂牌的唱片，标签上不印南方洋行的 logo 和店名（同 10/13 店主对李志 CD 的要求）。 */

const root = document.querySelector('[data-nh-shelf-root]');
if (root) {
  const ctl = controller(root);
  const host = root.querySelector('[data-nh-shelf]');
  if (host) stage(host, ctl).catch(err => console.warn('[nanpo] 3D shelf failed, keeping static shelf.', err));
}

/* 选中哪一张：左边文字、注记、目录、静态封面排都看这里；3D 场景订阅它 */
function controller(root){
  const tabs = [...root.querySelectorAll('[data-nh-tab]')];
  const parts = [...root.querySelectorAll('[data-nh-of]')];
  const fb = [...root.querySelectorAll('[data-nh-fb]')];
  const n = tabs.length;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const auto = (parseFloat(root.dataset.auto) || 0) * 1000;
  const subs = [];
  let cur = -1, lastUser = 0, hover = false, inView = true;
  function set(i, user){
    if (!n) return;
    i = ((i % n) + n) % n;
    if (user) lastUser = performance.now();
    if (i === cur) return;
    const prev = cur; cur = i;
    parts.forEach(el => { const on = +el.dataset.nhOf === i; el.hidden = !on; el.classList.toggle('is-on', on); });
    tabs.forEach((t, k) => { const on = k === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
    fb.forEach((f, k) => f.classList.toggle('is-on', k === i));
    root.style.setProperty('--nh-sel', i);
    subs.forEach(fn => fn(i, prev));
  }
  tabs.forEach((t, k) => {
    t.addEventListener('click', () => set(k, true));
    t.addEventListener('keydown', e => {
      const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      let to = null;
      if (d) to = cur + d;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = n - 1;
      if (to === null) return;
      e.preventDefault(); set(to, true); tabs[cur].focus();
    });
  });
  root.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hover = true; });
  root.addEventListener('pointerleave', () => { hover = false; });
  root.addEventListener('focusin', () => { lastUser = performance.now(); });
  new IntersectionObserver(en => { inView = en[0].isIntersecting; }, { threshold: 0.25 }).observe(root);
  if (auto && !reduce && n > 1) {
    setInterval(() => {
      if (document.hidden || !inView || hover || performance.now() - lastUser < auto * 2) return;
      set(cur + 1, false);
    }, auto);
  }
  set(0, false);
  return { n, get cur(){ return cur; }, set, on: fn => { subs.push(fn); } };
}

async function stage(host, ctl){
  const cfg = host.dataset;
  const items = JSON.parse((host.querySelector('[data-nh-items]') || {}).textContent || '[]');
  const n = items.length;
  if (!n) return;
  const canvas = host.querySelector('.nh-gl');
  const hero = host.closest('.nh-hero') || host;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const t0 = performance.now();

  const THREE = await import(cfg.three);
  const lib = await import(cfg.lib);
  let renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true, powerPreference: 'high-performance' });
  } catch (err) { console.warn('[nanpo] WebGL unavailable, keeping static shelf.', err); return; }
  /* 手机内存紧时浏览器会收回 WebGL 上下文，画布变空：这时停掉动画、退回静态封面排（文字和目录照样能换） */
  canvas.addEventListener('webglcontextlost', () => {
    renderer.setAnimationLoop(null);
    host.classList.remove('gl-on');
    console.warn('[nanpo] WebGL context lost, showing static shelf.');
  });

  const small = Math.min(innerWidth, innerHeight) < 700;
  renderer.setPixelRatio(Math.min(Math.max(window.devicePixelRatio || 1, 1.5), 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.VSMShadowMap;

  const scene = new THREE.Scene();
  const pmrem = new THREE.PMREMGenerator(renderer);
  scene.environment = pmrem.fromScene(lib.roomEnvironment(THREE), 0.04).texture;
  if ('environmentIntensity' in scene) scene.environmentIntensity = 0.55;

  /* ── 尺寸（和首屏一致：黑胶封套 S＝2 对应 12 吋；CD 盒按同一画法） ──
     机位按 5:4 的舞台用投影算过：四张轮流取下来，柜台上的这张和架子之间都留着空隙、都不出框（README §9.97）；
     舞台比 5:4 窄高时机位往后退 */
  const S = 2.0, FLOOR = -S / 2;
  const KS = 0.56, CD_SHELF = 0.72, CD_DESK = 0.82;   // 架上缩到 56%；CD 在架上再小一点（真实只有 LP 的 40%），放到柜台上是 82%
  const SLOT = 1.48, SHELF = new THREE.Vector3(0.15, 1.5, -2.2), LEAN = -0.06;   // 架上一格的间距；架子（中心、板面高度、前后）；靠墙后仰
  const DESK = new THREE.Vector3(-0.55, FLOOR, 0.8), DESK_RY = -0.32;            // 柜台上的位置和朝向（同原来的首屏：封面朝左前方，盘往右滑出）
  const BASE_CAM = new THREE.Vector3(0.0, 1.7, 9.2), LOOK = new THREE.Vector3(0.15, 0.35, 0), ASPECT = 1.25;
  let camK = 1;

  const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 40);
  camera.position.copy(BASE_CAM); camera.lookAt(LOOK);

  const key = new THREE.DirectionalLight(0xfff1dc, 2.8);
  key.position.set(2.4, 3.4, 3.6);
  key.castShadow = true;
  key.shadow.mapSize.set(small ? 1024 : 2048, small ? 1024 : 2048);
  Object.assign(key.shadow.camera, { left: -5, right: 5, top: 4, bottom: -4, near: 0.5, far: 16 });
  key.shadow.radius = 7; key.shadow.blurSamples = 18; key.shadow.bias = -0.0002;
  scene.add(key);
  scene.add(new THREE.HemisphereLight(0xfbfaf7, 0xcfc8ba, 0.6));
  const rim = new THREE.DirectionalLight(0xffffff, 0.9); rim.position.set(-3, 1.2, -2.6); scene.add(rim);

  const world = new THREE.Group(); scene.add(world);
  /* 收影子的地面只铺柜台这一块：铺满的话，架上唱片投到远处地面的影子在透视里正好落在柜台这张后面，连成一条灰带 */
  const ground = new THREE.Mesh(new THREE.PlaneGeometry(12, 5), new THREE.ShadowMaterial({ color: 0x14120e, opacity: 0.15 }));
  ground.rotation.x = -Math.PI / 2; ground.position.set(-0.2, FLOOR - 0.002, DESK.z + 0.3); ground.receiveShadow = true;
  world.add(ground);

  /* 墙上的架子：一块薄板 + 前沿的细边（纸色，哑光）；后面一面只收影子的墙；选中那格的前沿上一道墨色短线。
     架板本身不投影：它在墙上，投到柜台上会是一整条灰带（10/29 第二版看到的），墙上只留唱片自己的影子 */
  const shelfMat = new THREE.MeshStandardMaterial({ color: 0xe9e4d8, roughness: 0.9 });
  const edgeMat = new THREE.MeshStandardMaterial({ color: 0x14120e, roughness: 0.6 });
  const L = SLOT * (n - 1) + S * KS + 0.5;
  const board = new THREE.Mesh(new THREE.BoxGeometry(L, 0.05, 0.42), shelfMat);
  board.position.set(SHELF.x, SHELF.y - 0.025, SHELF.z + 0.06); board.receiveShadow = true;
  const lip = new THREE.Mesh(new THREE.BoxGeometry(L, 0.075, 0.025), shelfMat);
  lip.position.set(SHELF.x, SHELF.y + 0.01, SHELF.z + 0.26); lip.receiveShadow = true;
  /* 墙只留架板以上、唱片背后的一条：再往下，影子会滑到架板下面成一块灰 */
  const wall = new THREE.Mesh(new THREE.PlaneGeometry(L + 1, 1.5), new THREE.ShadowMaterial({ color: 0x14120e, opacity: 0.1 }));
  wall.position.set(SHELF.x, SHELF.y + 0.75, SHELF.z - 0.16); wall.receiveShadow = true;
  const slotMark = new THREE.Mesh(new THREE.BoxGeometry(S * KS * 0.5, 0.016, 0.004), edgeMat);
  slotMark.position.set(SHELF.x, SHELF.y + 0.01, SHELF.z + 0.2745);
  world.add(board, lip, wall, slotMark);

  /* 字体就绪后再画标签 */
  try {
    await Promise.race([Promise.all([document.fonts.ready, document.fonts.load('500 20px Jost')]), new Promise(r => setTimeout(r, 2500))]);
  } catch (e) { /* 字体失败不影响渲染 */ }
  const markTpl = host.querySelector('[data-nh-mark]');
  const mark = markTpl ? await lib.svgImage(markTpl.innerHTML.trim()) : null;

  const loader = new THREE.TextureLoader();
  const tex = url => url ? new Promise(res => loader.load(url, t => {
    t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = renderer.capabilities.getMaxAnisotropy(); res(t);
  }, undefined, () => res(null))) : Promise.resolve(null);

  /* 共用的材质和贴图 */
  const paperMat = new THREE.MeshStandardMaterial({ color: 0xefebe2, roughness: 0.93 });
  const caseMat = new THREE.MeshPhysicalMaterial({ color: 0x1d1c1b, roughness: 0.22, clearcoat: 1, clearcoatRoughness: 0.06 });
  const uvFix = (t, R) => { t.repeat.set(1 / (2 * R), 1 / (2 * R)); t.offset.set(0.5, 0.5); t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping; return t; };
  let groove = null, anisoLP = null, anisoCD = null;

  const mk = (geo, mats) => { const m = new THREE.Mesh(geo, mats); m.castShadow = true; m.receiveShadow = true; return m; };

  /* 一张唱片或 CD：item 的原点在底边中点（后仰、前倾都绕底边转），body 在 y＝S/2 */
  async function build(it, idx){
    const cd = !!it.cd;
    const AR = cd ? clamp(parseFloat(it.ar) || 1, 0.9, 1.25) : 1, W = S * AR;
    const BT = cd ? 0.026 : 0.012, GAP = cd ? 0.108 : 0.036;
    const cover = await tex(it.cover);
    const icfg = { artist: it.artist, title: it.title, sku: it.sku, c1: it.c1, c2: it.c2, c3: it.c3,
                   ring: `${it.artist} · ${it.title} · SIDE {side} · ` };
    const coverMat = cd
      ? new THREE.MeshPhysicalMaterial({ map: cover, color: cover ? 0xffffff : 0xd9d3c6, roughness: 0.5, clearcoat: 1, clearcoatRoughness: 0.04 })
      : new THREE.MeshStandardMaterial({ map: cover, color: cover ? 0xffffff : 0xd9d3c6, roughness: 0.58 });
    const backMap = lib.backTexture(THREE, icfg, AR);
    const backMat = cd
      ? new THREE.MeshPhysicalMaterial({ map: backMap, roughness: 0.9, clearcoat: 1, clearcoatRoughness: 0.04 })
      : new THREE.MeshStandardMaterial({ map: backMap, roughness: 0.93 });
    const side = cd ? caseMat : paperMat;
    const item = new THREE.Group(); item.rotation.order = 'YXZ'; item.userData.idx = idx;
    const body = new THREE.Group(); body.position.y = S / 2; item.add(body);
    const front = mk(new THREE.BoxGeometry(W, S, BT), [side, side, side, side, coverMat, side]); front.position.z = GAP / 2 + BT / 2;
    const back = mk(new THREE.BoxGeometry(W, S, BT), [side, side, side, side, side, backMat]); back.position.z = -(GAP / 2 + BT / 2);
    const IN = GAP - 0.002;
    const spine = mk(new THREE.BoxGeometry(BT, S - 2 * BT, IN), side); spine.position.x = -W / 2 + BT / 2;
    const topS = mk(new THREE.BoxGeometry(W, BT, IN), side); topS.position.y = S / 2 - BT / 2;
    const botS = mk(new THREE.BoxGeometry(W, BT, IN), side); botS.position.y = -S / 2 + BT / 2;
    body.add(front, back, spine, topS, botS);
    item.scale.setScalar(KS * (cd ? CD_SHELF : 1));
    item.userData.disc = null;
    item.userData.make = () => makeDisc(it, icfg, cd);    // 盘第一次被选中时才建，开场快一点
    item.userData.slideMax = cd ? 1.0 : 1.08;
    item.userData.body = body;
    return item;
  }

  async function makeDisc(it, icfg, cd){
    const R = cd ? 0.96 : 0.985, HOLE = cd ? 0.12 : 0.036, TH = cd ? 0.0192 : 0.014, BEV = 0.0045;
    const shape = new THREE.Shape(); shape.absarc(0, 0, R, 0, Math.PI * 2, false);
    const hole = new THREE.Path(); hole.absarc(0, 0, HOLE, 0, Math.PI * 2, true); shape.holes.push(hole);
    const geo = new THREE.ExtrudeGeometry(shape, { depth: TH - 2 * BEV, bevelEnabled: true, bevelThickness: BEV, bevelSize: BEV, bevelOffset: -BEV, bevelSegments: 3, curveSegments: 200 });
    geo.translate(0, 0, -(TH - 2 * BEV) / 2); geo.computeVertexNormals();
    const disc = new THREE.Group();
    if (cd) {
      anisoCD = anisoCD || uvFix(lib.anisoTexture(THREE, small ? 256 : 512, true), R);
      const dataMat = new THREE.MeshPhysicalMaterial({ color: 0xd6d8dc, metalness: 1, roughness: 0.14, iridescence: 1, iridescenceIOR: 1.5,
        iridescenceThicknessRange: [180, 820], anisotropy: 0.9, anisotropyMap: anisoCD, envMapIntensity: 1.35 });
      const rimMat = new THREE.MeshPhysicalMaterial({ color: 0xcfd2d6, metalness: 0.55, roughness: 0.24, clearcoat: 1, clearcoatRoughness: 0.1 });
      const base = new THREE.Mesh(geo, [dataMat, rimMat]); base.castShadow = true; base.receiveShadow = true;
      const photo = it.label ? await lib.loadImage(it.label) : null;
      const pr = lib.cdPrintTextures(THREE, null, icfg, R, HOLE, small ? 1024 : 2048, photo);
      const printMat = new THREE.MeshPhysicalMaterial({ map: pr.map, roughnessMap: pr.mr, metalnessMap: pr.mr, roughness: 1, metalness: 1,
        clearcoat: 0.45, clearcoatRoughness: 0.28, envMapIntensity: 1.1 });
      const face = new THREE.Mesh(new THREE.RingGeometry(HOLE + 0.002, R - 0.004, 200), printMat);
      face.position.z = TH / 2 + 0.0008; face.receiveShadow = true;
      disc.add(base, face);
    } else {
      groove = groove || uvFix(lib.grooveTexture(THREE, small ? 1024 : 2048), R);
      anisoLP = anisoLP || uvFix(lib.anisoTexture(THREE, small ? 256 : 512, true), R);
      const col = String(it.disc || 'black').trim().toLowerCase();
      const hex = /^#[0-9a-f]{6}$/.test(col) ? col : null, clear = col === 'clear';
      const common = { roughnessMap: groove, bumpMap: groove, bumpScale: 0.35, metalness: 0, clearcoat: 1, clearcoatRoughness: 0.14,
        anisotropy: 1, anisotropyMap: anisoLP, envMapIntensity: 1.15 };
      const vinylMat = new THREE.MeshPhysicalMaterial(Object.assign(common,
        clear ? { color: 0xc9d3da, roughness: 0.2, transparent: true, opacity: 0.72, depthWrite: false }
          : hex ? { color: new THREE.Color(hex), roughness: 0.4, transparent: true, opacity: 0.88 }
            : { color: 0x121110, roughness: 0.5 }));
      const ec = hex ? new THREE.Color(hex).multiplyScalar(0.7) : new THREE.Color(clear ? 0xc9d2d8 : 0x0e0d0c);
      const edge = new THREE.MeshPhysicalMaterial({ color: ec, roughness: 0.55, clearcoat: 0.5, clearcoatRoughness: 0.3,
        transparent: clear, opacity: clear ? 0.6 : 1 });
      const record = new THREE.Mesh(geo, [vinylMat, edge]); record.castShadow = true; record.receiveShadow = true;
      const labGeo = new THREE.RingGeometry(HOLE + 0.002, 0.335, 140);
      const labA = new THREE.Mesh(labGeo, new THREE.MeshStandardMaterial({ map: lib.labelTexture(THREE, 'A', null, icfg), roughness: 0.9 }));
      labA.position.z = TH / 2 + 0.0008;
      const labB = new THREE.Mesh(labGeo, new THREE.MeshStandardMaterial({ map: lib.labelTexture(THREE, 'B', null, icfg), roughness: 0.9 }));
      labB.position.z = -TH / 2 - 0.0008; labB.rotation.y = Math.PI;
      disc.add(record, labA, labB);
    }
    return disc;
  }

  const objs = await Promise.all(items.map((it, i) => build(it, i)));
  objs.forEach(o => world.add(o));

  /* 每张的当前状态（位置、朝向、前倾、大小、盘滑出多少）；架上第 i 格的位置 */
  const slotX = i => SHELF.x + (i - (n - 1) / 2) * SLOT;
  const kShelf = i => KS * (items[i].cd ? CD_SHELF : 1), kDesk = i => items[i].cd ? CD_DESK : 1;
  const st = objs.map((o, i) => ({ x: slotX(i), y: SHELF.y, z: SHELF.z, ry: 0, rx: LEAN, slide: 0, spin: i * 1.7, k: kShelf(i) }));
  const ui = { hover: -1, px: 0, py: 0, tx: 0, ty: 0, intro: 0 };

  /* 选中时把盘建好（只建一次） */
  async function ensureDisc(i){
    const o = objs[i];
    if (o.userData.disc || o.userData.pending) return;
    o.userData.pending = true;
    const d = await o.userData.make();
    d.visible = false; o.userData.body.add(d); o.userData.disc = d;
  }
  const go = host.querySelector('[data-nh-go]');
  ctl.on(i => { ensureDisc(i); if (go) go.hidden = true; });
  if (ctl.cur >= 0) ensureDisc(ctl.cur);

  /* 输入：指针带动光和一点视角；点选、悬停、左右滑 */
  const ray = new THREE.Raycaster(), ndc = new THREE.Vector2();
  const pick = e => {
    const r = host.getBoundingClientRect();
    ndc.set(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
    ray.setFromCamera(ndc, camera);
    const hit = ray.intersectObjects(objs, true)[0];
    let o = hit ? hit.object : null;
    while (o && o.userData.idx === undefined) o = o.parent;
    return o ? o.userData.idx : -1;
  };
  let down = null, lastHover = 0;
  host.addEventListener('pointerdown', e => { down = { x: e.clientX, y: e.clientY }; });
  host.addEventListener('pointerup', e => {
    const d0 = down; down = null;
    if (!d0 || e.target.closest('a')) return;
    const dx = e.clientX - d0.x, dy = e.clientY - d0.y;
    if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) { ctl.set(ctl.cur + (dx < 0 ? 1 : -1), true); return; }
    if (Math.hypot(dx, dy) > 8) { if (go) go.hidden = true; return; }
    const i = pick(e);
    if (i < 0) { if (go) go.hidden = true; return; }
    if (i !== ctl.cur) { ctl.set(i, true); return; }
    if (!go) return;
    const r = host.getBoundingClientRect();
    go.href = items[i].href;
    go.style.left = clamp(e.clientX - r.left, 90, r.width - 90) + 'px';
    go.style.top = clamp(e.clientY - r.top, 70, r.height - 10) + 'px';
    go.hidden = false;
    go.classList.remove('is-in'); void go.offsetWidth; go.classList.add('is-in');
  });
  /* 指针在架上的一张上停一下就换成它（店主：「鼠标放上去有选择」）；从一张移到另一张时重新计时 */
  let dwell = 0;
  host.addEventListener('pointermove', e => {
    if (e.pointerType !== 'mouse') return;
    const now = performance.now();
    if (now - lastHover < 50) return;
    lastHover = now;
    const h = pick(e);
    if (h !== ui.hover) {
      ui.hover = h;
      clearTimeout(dwell);
      if (h >= 0 && h !== ctl.cur) dwell = setTimeout(() => { if (ui.hover === h) ctl.set(h, true); }, 260);
    }
    host.classList.toggle('is-over', ui.hover >= 0);
  }, { passive: true });
  host.addEventListener('pointerleave', () => { ui.hover = -1; clearTimeout(dwell); host.classList.remove('is-over'); });
  document.addEventListener('pointerdown', e => { if (go && !host.contains(e.target)) go.hidden = true; });
  document.addEventListener('keydown', e => { if (go && e.key === 'Escape') go.hidden = true; });
  hero.addEventListener('pointermove', e => {
    const r = host.getBoundingClientRect();
    ui.tx = clamp(((e.clientX - r.left) / r.width - 0.5) * 2, -1.8, 1.8);
    ui.ty = clamp(((e.clientY - r.top) / r.height - 0.5) * 2, -1.8, 1.8);
  }, { passive: true });
  hero.addEventListener('pointerleave', () => { ui.tx = 0; ui.ty = 0; });

  function resize(){
    const w = host.clientWidth || 1, h = host.clientHeight || 1;
    renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix();
    camK = Math.max(1, ASPECT / camera.aspect);
  }
  new ResizeObserver(resize).observe(host); resize();
  let visible = true;
  new IntersectionObserver(en => { visible = en[0].isIntersecting; }, { threshold: 0.01 }).observe(host);

  let first = true, last = performance.now(), t = 0;
  const damp = (a, b, k, dt) => a + (b - a) * (1 - Math.exp(-k * dt));
  function frame(){
    const now = performance.now(); const dt = Math.min((now - last) / 1000, 0.05); last = now; t += dt;
    if (!visible && !first) return;
    ui.intro = Math.min(1, ui.intro + dt / 1.6);
    const ei = reduce ? 1 : 1 - Math.pow(1 - ui.intro, 3);
    const K = reduce ? 30 : 5.5;
    ui.px = damp(ui.px, ui.tx, 3.5, dt); ui.py = damp(ui.py, ui.ty, 3.5, dt);
    objs.forEach((o, i) => {
      const s = st[i], sel = i === ctl.cur, hov = i === ui.hover && !sel;
      const tg = sel
        ? { x: DESK.x, y: DESK.y, z: DESK.z, ry: DESK_RY, rx: 0, k: kDesk(i) }
        : { x: slotX(i), y: SHELF.y + (hov ? 0.09 : 0), z: SHELF.z + (hov ? 0.06 : 0), ry: 0, rx: hov ? 0.05 : LEAN, k: kShelf(i) };
      const far = Math.hypot(tg.x - s.x, tg.y - s.y, tg.z - s.z);
      /* 架子和柜台之间来回时走一道往前、往上鼓的弧：取下来时先朝自己拿出来，放回去时从前上方落进那一格，不穿过架板和别的唱片 */
      const bow = Math.min(1, far / 2.5);
      s.x = damp(s.x, tg.x, K, dt);
      s.y = damp(s.y, tg.y + bow * 0.45, K, dt);
      s.z = damp(s.z, tg.z + bow * 0.9, K, dt);
      s.ry = damp(s.ry, tg.ry, K, dt); s.rx = damp(s.rx, tg.rx, K * 1.2, dt);
      s.k = damp(s.k, tg.k, K, dt);
      const d = o.userData.disc;
      const slideTo = sel && far < 0.3 && d ? o.userData.slideMax : 0;
      s.slide = damp(s.slide, slideTo, sel ? 3.2 : 9, dt);
      if (d) {
        d.visible = s.slide > 0.01;
        d.position.x = s.slide;
        if (!reduce) s.spin -= dt * 0.32;
        d.rotation.z = s.spin;
      }
      o.scale.setScalar(s.k);
      o.position.set(s.x, s.y, s.z);
      o.rotation.set(s.rx, s.ry, 0);
    });
    if (ctl.cur >= 0) slotMark.position.x = damp(slotMark.position.x, slotX(ctl.cur), K, dt);
    world.position.y = (1 - ei) * -0.5;
    camera.position.set(LOOK.x + (BASE_CAM.x - LOOK.x) * camK + ui.px * 0.22, LOOK.y + (BASE_CAM.y - LOOK.y) * camK - ui.py * 0.12, LOOK.z + (BASE_CAM.z - LOOK.z) * camK);
    camera.lookAt(LOOK);
    key.position.set(2.4 + ui.px * 2.6, 3.4 - ui.py * 1.8, 3.6);
    renderer.render(scene, camera);
    if (first) { first = false; host.classList.add('gl-on'); console.info(`[nanpo] 3D shelf ready in ${Math.round(performance.now() - t0)} ms`); }
  }
  renderer.setAnimationLoop(frame);
}

